import { render, staticRenderFns } from "./TooltipSwitch.vue?vue&type=template&id=5b477006&scoped=true"
import script from "./TooltipSwitch.vue?vue&type=script&lang=js"
export * from "./TooltipSwitch.vue?vue&type=script&lang=js"
import style0 from "./TooltipSwitch.vue?vue&type=style&index=0&id=5b477006&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b477006",
  null
  
)

export default component.exports